var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    clipPath: "url(#clip0_45_3759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9532 8.6535C12.9799 8.44016 12.9999 8.22683 12.9999 8.00016C12.9999 7.7735 12.9799 7.56016 12.9532 7.34683L14.3599 6.24683C14.4866 6.14683 14.5199 5.96683 14.4399 5.82016L13.1066 3.5135C13.0266 3.36683 12.8466 3.3135 12.6999 3.36683L11.0399 4.0335C10.6932 3.76683 10.3199 3.54683 9.91323 3.38016L9.65989 1.6135C9.63989 1.4535 9.49989 1.3335 9.33323 1.3335H6.66656C6.49989 1.3335 6.35989 1.4535 6.33989 1.6135L6.08656 3.38016C5.67989 3.54683 5.30656 3.7735 4.95989 4.0335L3.29989 3.36683C3.14656 3.30683 2.97323 3.36683 2.89323 3.5135L1.55989 5.82016C1.47323 5.96683 1.51323 6.14683 1.63989 6.24683L3.04656 7.34683C3.01989 7.56016 2.99989 7.78016 2.99989 8.00016C2.99989 8.22016 3.01989 8.44016 3.04656 8.6535L1.63989 9.7535C1.51323 9.8535 1.47989 10.0335 1.55989 10.1802L2.89323 12.4868C2.97323 12.6335 3.15323 12.6868 3.29989 12.6335L4.95989 11.9668C5.30656 12.2335 5.67989 12.4535 6.08656 12.6202L6.33989 14.3868C6.35989 14.5468 6.49989 14.6668 6.66656 14.6668H9.33323C9.49989 14.6668 9.63989 14.5468 9.65989 14.3868L9.91323 12.6202C10.3199 12.4535 10.6932 12.2268 11.0399 11.9668L12.6999 12.6335C12.8532 12.6935 13.0266 12.6335 13.1066 12.4868L14.4399 10.1802C14.5199 10.0335 14.4866 9.8535 14.3599 9.7535L12.9532 8.6535ZM7.99989 10.3335C6.71323 10.3335 5.66656 9.28683 5.66656 8.00016C5.66656 6.7135 6.71323 5.66683 7.99989 5.66683C9.28656 5.66683 10.3332 6.7135 10.3332 8.00016C10.3332 9.28683 9.28656 10.3335 7.99989 10.3335Z",
    fill: "#7C8D7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_3759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.43590b1e277192ff607af984db620278.svg";
export { ForwardRef as ReactComponent };